import pipe from 'lodash/fp/pipe'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import {ApplicationState} from '../../rootReducer'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Utils from './utils'

const onOpen = (constants: Utils.ConstantsMap) => (
  action$: ReduxObservable.ActionsObservable<Actions.DetailPanelAction<any>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(constants[Constants.OPEN], constants[Constants.TOGGLE])
  .map((action) => ({action, state: store.getState()}))

export const createOnOpen = pipe(
  Utils.createConstantsMap,
  onOpen,
)



// WEBPACK FOOTER //
// ./src/components/detail-panel/epic.ts